export enum AuthMode {
  LOGIN = 'login',
  SIGNUP = 'signup',
}

/**
 * guest: new user
 * customer: customer
 * subscriber: customer with Marketing Subscription
 */
export enum UserType {
  Guest = 'guest',
  Customer = 'customer',
  Subscriber = 'subscriber',
}

export enum OAuthMethod {
  Google = 'google',
}

export enum LoginStep {
  AUTH = 'auth',
  OTP = 'otp',
  EMAIL_SELECTION = 'emailSelection',
  USER_INFO = 'userInfo',
  PHONE_VERIFICATION = 'phoneVerification',
  WELCOME = 'welcome',
  SIGN_UP = 'signUp',
  OTP_ERROR = 'otpError',
  OTP_HELP_CONFIRM = 'otpHelpConfirm',
}

export const LOGIN_STEPS = [
  LoginStep.AUTH,
  LoginStep.OTP,
  LoginStep.EMAIL_SELECTION,
  LoginStep.USER_INFO,
  LoginStep.PHONE_VERIFICATION,
  LoginStep.WELCOME,
  LoginStep.SIGN_UP,
  LoginStep.OTP_ERROR,
  LoginStep.OTP_HELP_CONFIRM,
] as const;
